import React from "react";
import { useTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const Title = props => {
	const theme = useTheme();
	return (
		<Typography component="h2" variant="h6" color={theme.palette.type === "dark" ? "textPrimary" : "primary"} gutterBottom>
			{props.children}
		</Typography>
	);
};

export default Title;
